import React from "react";
import { View, StyleSheet, Image, FlatList, TouchableWithoutFeedback, ImageBackground, ActivityIndicator, ScrollView, RefreshControl } from "react-native";
import { Surface } from "react-native-paper"
import { connect } from "react-redux";

import { getTestSeriesList } from "./../../store/actions";
import {
  Text,
  Styles,
  SlideUp,
} from "./../../components/UI-Components";

import { Forward } from '@material-ui/icons';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import AdsScreen from './../Ads';
import Header from './../../components/Header/index';
import { TouchableScale } from './../../components';
import Container from '@material-ui/core/Container';


// import OfflineHandler from './../OfflineHandler';
const Loader = require('./../../assets/loadingGif.gif');


const shadowOpt = (elevation) => {
  return {
    elevation,
    shadowColor: 'black',
    shadowOffset: { width: 0, height: 0.5 * elevation },
    shadowOpacity: 0.3,
    shadowRadius: 0.8 * elevation,
  }

}

const getSubjectNames = (info) => {
  const _subjects = [];
  info && info.length > 0 && info.map(sub => {
    const subjectName = sub && sub.subjectdetails && sub.subjectdetails.subject_name;
    if (subjectName) _subjects.push(subjectName)
  })
  return _subjects;
}

const TestSeriesComponent = ({ testSeriesData, navigation }) => {
  const {
    _daily_test,
    is_discount,
    discount_price,
    image_url,
    title,
    actual_price,
    mock_series_code,
    exam_code,
    
    mock_series_payment,
    mockseries_subjects,
  } = testSeriesData;


  const subjectNames = getSubjectNames(mockseries_subjects)
  const { status = null } = mock_series_payment && mock_series_payment[0] || {};
  let isFree = false;
  let price = _daily_test ? 'Free' : is_discount ? '₹' + discount_price : ' ';
  let actualPrice = parseInt(actual_price, 10) < 1 ? "FREE" : '₹' + actual_price;
  if (parseInt(actual_price, 10) < 1) isFree = true;

  return (
    <TouchableScale
      onPress={() => navigation.push('/TestSeriesTestList', {
        testSeriesId: mock_series_code,
           subjectNames: subjectNames,
           title: title
        
      })}
      activeOpacity={1}
    >
      <View style={styles.testSeries}>
        <ImageBackground
          source={{ uri: image_url }}
          style={{ width: '100%', height: '100%', position: 'relative' }}
          resizeMode='cover'
          imageStyle={{ borderRadius: 10, overflow: 'hidden' }}
        >
          <View style={{ flex: 1, justifyContent: 'center', alignItems: 'flex-start', lineHeight: 1.2,
           paddingLeft: 6, paddingRight: 20, position: 'relative', zIndex: 200 }}>
            <Text style={{ color: '#fff', fontSize: 26, fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 1.2 }}>
              {title}
            </Text>
          </View>
          {
            !status && <View style={{
              position: 'absolute',
              //marginBottom: -10, 
              // borderWidth: 2,
              // borderColor: '#fff',
              zIndex: 10000,
              bottom: 0,
              right: 0,
              width: 70,
              // paddingHorizontal: 20,
              backgroundColor: isFree ? '#00de2b' : '#ffba00',
              borderTopWidth: 2,
              borderLeftWidth: 2,
              paddingVertical: 10,
              borderColor: '#fff',
              borderTopStartRadius: 130,
              alignItems: 'center',
              // borderBottomStartRadius: 50,
              borderBottomRightRadius: 10,
            }}>
              <Text style={{ fontSize: 19, fontWeight: 'bold', fontStyle: 'italic' }}>{actualPrice}</Text>
            </View>
          }
          <View
            style={{
              position: 'absolute',
              top:0,
              left:0,right:0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.55)',
              zIndex: 1,
              borderRadius: 10,
            }}
          />
        </ImageBackground>
      </View>
    </TouchableScale>
  )
}


class TestSeriesListComponent extends React.Component {


  state = {
    refreshing: false,
    isAdShow: false,
  }


  componentDidMount() {
    this.props.getTestSeriesList();
  }
  _onRefresh = () => {
    this.setState({
      refreshing: true
    })
    this.props.getTestSeriesList();
    // this.props.clearLibrarySubjectsData()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.testSeriesListDetails !== this.props.testSeriesListDetails) {
      if (this.props.testSeriesListDetails) {
        this.setState({
          refreshing: false
        })
      }
    }
  }

  isAd = () => {
    this.setState({
      isAdShow: true
    })
  }

  render() {

    return (
      <>
        <Header
          title="Exams"
        // headerRight
        // headerRightClick={() => alert()}
        />
        <Container maxWidth='md'>
          <div className='main-component'
          // style={{flex:1, backgroundColor:Styles.white, height: '90vh', elevation :4, paddingVertical: 30}}
          >
            {
              this.props.loading ? (
                <View style={{ width: '100%', height: '90vh', justifyContent: 'center', alignItems: 'center', }}>
                  {/* <ActivityIndicator /> */}
                  <Image source={Loader} style={{ width: 250, height: 250 }} />
                </View>
              ) : null
            }

            <ScrollView
              // style={{ flex: 1, }}
            >

              <View style={{ marginTop: 5, width:'100%',  paddingBottom: this.state.isAdShow ? 50 : 0 }}>
                {

                  this.props.testSeriesListDetails && Object.keys(this.props.testSeriesListDetails).map(x => {
                    return (
                      <React.Fragment>
                        <Text style={styles.testTitle}>{`${x} Test Series`}</Text>
                        <FlatList
                          data={this.props.testSeriesListDetails && this.props.testSeriesListDetails[x]}
                          renderItem={({ item }, index = 1) =>
                            <SlideUp
                              duration={200 * index}
                              animationDirection={'left'}
                            >
                              <TestSeriesComponent
                                testSeriesData={item}
                                navigation={this.props.history}
                              />
                            </SlideUp>
                          }
                          horizontal={true}
                          showsHorizontalScrollIndicator={false}
                          keyExtractor={item => item.mock_series_code}
                        />

                      </React.Fragment>
                    )
                  })
                }
              </View>

            </ScrollView>
            {/* <AdsScreen screenName={'MyTests'}  isAdCallBack={this.isAd}/> */}
          </div>
        </Container>
      </>
    )
  }
}

const styles = StyleSheet.create({
  testSeries: {
    marginTop: 5,
    marginLeft: 10,
    height: 300,
    // width: '30%',
    width: 250,
    // minHeight: 150,
    backgroundColor: Styles.white,
    borderRadius: 10,
    elevation: 7,
    shadowColor: '#000',
    shadowOffset: { width: 1, height: 0 },
    shadowOpacity: 0.1,
    marginHorizontal: 10,
    marginVertical: 10,
    // padding: 10,
    // height: 150


  },
  priceList: {
    fontSize: 11,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: Styles.testSeriesListColor,
    opacity: 0.6,
    marginVertical: 10,
    // borderWidth: 1,
    // flex:1,
    // margin:'auto'

  },
  priceTitle: {
    color: Styles.testSeriesListColor,
    fontSize: 11,
    paddingRight: 10,


  },
  strikePrice: {
    color: Styles.testSeriesListColor,
    fontSize: 11,
    textDecorationLine: 'line-through',
    paddingRight: 10,
  },
  testTitle: {
    marginHorizontal: 10,
    marginVertical: 0,
    marginTop: 10,
    fontSize: 15,
    fontWeight: '500',
    marginBottom: 10

  },


  purchasedIcon: {
    justifyContent: 'flex-end',

    marginVertical: 10,
    flexDirection: 'row'

  },
  dividerLine: {
    borderWidth: 0.2,
    borderColor: Styles.blackLight
  },

  typesOfChallenges: {
    flex: 0.5,
  },

  iconForChallenge: {
    width: 10,
    height: 10,
    color: "#fff",
    resizeMode: 'contain',

  },

  iconComponent: {
    width: 16,
    height: 16,
    borderRadius: 100,
    // backgroundColor:'#f00',
    justifyContent: 'center',
    alignItems: 'center'
  },
  shadow: {
    shadowColor: 'rgba(0,0,0,0.8)',
    shadowOffset: {
      width: 0,
      height: 10,
    },
    shadowOpacity: 0.4,
    shadowRadius: 8,
    elevation: 21,
    // borderWidth:3, 
  },
  _shadow: {
    marginBottom: 10,
    //  borderWidth:3, 
    borderRadius: 10,
    shadowColor: 'rgba(0,0,0,0.7)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.68,
    elevation: 11,
  }
})

const mapStateToProps = state => ({

  testSeriesListDetails: state.testSeriesListInfo && state.testSeriesListInfo.response && state.testSeriesListInfo.response.data
    && state.testSeriesListInfo.response.data.mock_series_list,
  loading: state.testSeriesListInfo && state.testSeriesListInfo.loading,
  // testDetails: testSeriesListInfoSelector(state)       
  stateInfo: state
})

export default connect(mapStateToProps, { getTestSeriesList })(TestSeriesListComponent);
